// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ballsColor {
  width: 15px;
  height: 15px;
  font-size: 1px;
  border-radius: 35px;
}

.statusCurrentCard {
  display: flex;
  padding-left: 4px;
}

.statusCurrentCard span {
  font-size: 18px;
  font-weight: 400;
  font-family: "Bosch Sans", sans-serif;
}

@media (max-width: 1280px) {
  .statusCurrentCard span {
    max-width: 180px;
  }
}

.cardColors {
  display: flex;
  align-items: center;
  border-top: 4px solid;
  height: 110px;
  background-color: #fff;
  border-color: #007bc0;
  position: relative;
}

.iconCard {
  height: 100%;
  padding-top: 15px;
  padding-left: 15px;
}
.infoCard {
  position: relative;
  height: 100%;
  padding-top: 30px;
}

.iconExplain {
  position: absolute;
  right: 20px;
  top: 20px;
  cursor: pointer;
  z-index: 10;
}

.statusQty {
  position: absolute;
  bottom: 24px;
}
.statusQty span {
  font-size: 28px;
  font-weight: 700;
}

.info-btn{
  padding: 0;
}
`, "",{"version":3,"sources":["webpack://./src/componentes/fluxo-engenheiro/CardDashboard/cardColor.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qCAAqC;AACvC;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,eAAe;EACf,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,YAAY;AACd;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,UAAU;AACZ","sourcesContent":[".ballsColor {\n  width: 15px;\n  height: 15px;\n  font-size: 1px;\n  border-radius: 35px;\n}\n\n.statusCurrentCard {\n  display: flex;\n  padding-left: 4px;\n}\n\n.statusCurrentCard span {\n  font-size: 18px;\n  font-weight: 400;\n  font-family: \"Bosch Sans\", sans-serif;\n}\n\n@media (max-width: 1280px) {\n  .statusCurrentCard span {\n    max-width: 180px;\n  }\n}\n\n.cardColors {\n  display: flex;\n  align-items: center;\n  border-top: 4px solid;\n  height: 110px;\n  background-color: #fff;\n  border-color: #007bc0;\n  position: relative;\n}\n\n.iconCard {\n  height: 100%;\n  padding-top: 15px;\n  padding-left: 15px;\n}\n.infoCard {\n  position: relative;\n  height: 100%;\n  padding-top: 30px;\n}\n\n.iconExplain {\n  position: absolute;\n  right: 20px;\n  top: 20px;\n  cursor: pointer;\n  z-index: 10;\n}\n\n.statusQty {\n  position: absolute;\n  bottom: 24px;\n}\n.statusQty span {\n  font-size: 28px;\n  font-weight: 700;\n}\n\n.info-btn{\n  padding: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
